import {useMutation, useQuery} from "react-query"
import defaultAxios from "lib/http/http.common"
import {ApiResponse} from "dto/ApiResponse"
import {Role} from "dto/Role"
import {queryClient} from "index"
import {User} from "dto/User"

const findAllRolesQueryKey = "findAllRoles"
const findRoleByNameQueryKey = "findByRole"
const findRoleCompositesByNameQueryKey = "findRoleCompositesByNameQueryKey"
const findUserMembersByNameQueryKey = "findUserMemberByNameQueryKey"
export const useFindAllRoles = () => {
    return useQuery(findAllRolesQueryKey, async () => {
        const response = await defaultAxios.get<ApiResponse<Role[]>>("/role")
        return response.data?.body
    })
}

export const useFindRoleByName = (name?: string) => {
    return useQuery([findRoleByNameQueryKey, name], async () => {
        const response = await defaultAxios.get<ApiResponse<Role>>(`/role/${name}`)
        return response.data?.body
    }, {
        enabled: !!name
    })
}

export const useDeleteRole = () => {
    return useMutation(async (name: string) => {
        await defaultAxios.delete(`/role/${name}`)
        await queryClient.invalidateQueries(findAllRolesQueryKey)
    })
}

export const useFindRoleCompositesByName = (name?: string) => {
    return useQuery([findRoleCompositesByNameQueryKey, name], async () => {
        const response = await defaultAxios.get<ApiResponse<Role[]>>(`/role/${name}/composites`)
        return response.data?.body
    }, {
        enabled: !!name
    })
}

export const useFindUserMembersByName = (name?: string) => {
    return useQuery([findUserMembersByNameQueryKey, name], async () => {
        const response = await defaultAxios.get<ApiResponse<User[]>>(`/role/${name}/user-members`)
        return response.data?.body
    }, {
        enabled: !!name
    })
}


export const useRegisterRole = () => {
    return useMutation(async (role: Role) => {
        await defaultAxios.post("/role", role)
        await queryClient.invalidateQueries(findAllRolesQueryKey)
    })
}

export const useUpdateRole = () => {
    return useMutation(async (role: Role) => {
        await defaultAxios.put("/role", role)
        await queryClient.invalidateQueries(findAllRolesQueryKey)
        await queryClient.invalidateQueries(findRoleByNameQueryKey)
    })
}

export const useAddCompositesToRole = () => {
    return useMutation(async (params: { roleName: string, itemName: string }) => {
        await defaultAxios.put(`/role/${params.roleName}/composites/${params.itemName}`)
        await queryClient.invalidateQueries(findRoleCompositesByNameQueryKey)
    },)
}

export const useDeleteCompositesToRole = () => {
    return useMutation(async (params: { roleName: string, itemName: string }) => {
        await defaultAxios.delete(`/role/${params.roleName}/composites/${params.itemName}`)
        await queryClient.invalidateQueries(findRoleCompositesByNameQueryKey)
    },)
}